export type Sidebar = {
  isOpen: boolean;
  current: string;
  offerIndex?: number;
};

export interface CustomerLead {
  userID: string;
  mobile: string;
  sourceEntityID: string;
}
export interface Store {
  sidebar: Sidebar;
  closeSidebar: () => void;
  setSidebar: (args: Sidebar) => void;
  existingOffers: LoanData[];
  customerData: CustomerLead;

  setExistingOffers: (args: LoanData[]) => void;
  selectedOffer: LoanData;
  offerCalculation: any;
  setOfferCalculation: any;
  setSelectedOffer: (args: LoanData) => void;
  setCustomerData: (args: CustomerLead) => void;
}

export type AdditionalParameters = {
  businessAddressCity: string;
  businessAddressLandmark: string;
  businessAddressLine1: string;
  businessAddressLine2: string;
  businessAddressPincode: string;
  businessAddressState: string;
  businessName: string;
  currentAddressCity: string;
  currentAddressLandMark: string;
  currentAddressLine1: string;
  currentAddressLine2: string;
  currentAddressPincode: string;
  currentAddressState: string;
  dateOfIncorporation: string; // Consider using Date type if parsing is required
  dob: string; // Consider using Date type if parsing is required
  firstName: string;
  gender: "Male" | "Female"; // Adjust if there are other possible values
  industry: string;
  lastName: string;
  middleName: string;
  natureOfBusiness: string;
  occupation: string;
  pan: string;
  repaymentAccountType: string;
  repaymentBankAccountNumber: string;
  repaymentBankName: string;
  repaymentIFSCCode: string;
  subindustry: string;
  typeOfBusiness: string;
  ucidID: string;
  udyamNumber: string;
  minAmount: string;
  maxAmount: string;
  minTenure: string;
  maxTenure: string;
};

export type LoanData = {
  amount: number;
  lenderID: string;
  lenderName: string;
  sourceEntityID: string;
  sourceEntityName: string;
  processingFee: number;
  processingFeeType: "PERC" | "FIX"; // Assuming "PERC" and "FIX" are the only values
  tenure: number;
  interest: number;
  createdAt: string; // Consider using Date type if parsing is required
  partner_code: string;
  additionalParameters: AdditionalParameters;
};

export type LoanTermsData = {
  loanAmount: number;
  loanTenure: number;
  rateOfInterset: number;
  tenureType: 1;
};

export enum LoanTermsEnum {
  LOAN_AMOUNT = 1,
  RATE_OF_INTERSET = 2,
  LOAN_TENURE = 3,
}

export enum BreakDownColors {
  PRINCIPAL_AMOUNT = "#094c8c",
  INTERSET_PAYABLE = "#7eb7fd",
}

export type DisqualificationReason = {
  code: string;
  description: string;
  // Reject / Review (or Refer) as configured in the rule master.
  status?: string;
};

export type AddUserError = {
  message?: string;
  displayErrorMessagePopup?: boolean;
  disqualificationReasons?: DisqualificationReason[];
};
